import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GenericDropDownV3, SimpleListAdapter, TS_DropDown, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { ICONS } from '@app/styles';
import { actionTypes } from '@app/pathway-shared';
import { ModuleFE_Action } from './ModuleFE_Action.js';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
export const Props_ActionDropDown = {
    module: ModuleFE_Action,
    modules: [ModuleFE_Action],
    mapper: item => [item.name],
    placeholder: 'Choose an action',
    renderer: item => _jsx("div", { className: "node-data", children: item.name }),
    sortBy: [item => item.name.toLowerCase()]
};
export const DropDown_Action = GenericDropDownV3.prepare(Props_ActionDropDown);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_Action,
    itemRenderer: (item, onDelete, disabled) => {
        return !item ? _jsx(_Fragment, { children: "Not Found" }) : _jsxs(_Fragment, { children: [!disabled &&
                    _jsx(ICONS.x.component, { onClick: onDelete, className: 'ts-icon__small' }), item.name] });
    },
    uiSelector: DropDown_Action.selectable,
});
export const MultiSelect_Action = TS_MultiSelect_V2.prepare(Props_MultiSelect);
export const Props_InterflowDropDown = {
    module: ModuleFE_Action,
    modules: [ModuleFE_Action],
    mapper: item => [item.name],
    placeholder: 'Choose An Interflow',
    caret: DropDown_DefaultCaret,
    queryFilter: (item) => item.type === 'interflow',
    renderer: item => _jsx("div", { className: "node-data", children: item.name })
};
export const DropDown_Interflow = GenericDropDownV3.prepareEditable(Props_InterflowDropDown);
export const Props_ActionTypeDropdown = {
    adapter: SimpleListAdapter(actionTypes, type => _jsx(_Fragment, { children: type.item })),
    caret: DropDown_DefaultCaret,
    placeholder: 'Select Action Type',
};
export const Dropdown_ActionType = TS_DropDown.prepare(Props_ActionTypeDropdown);
//# sourceMappingURL=ui-components.js.map